import { CreateCareerReq, CreateFormationReq, CreateProjectElementReq, CreateProjectElementWithTextReq, CreateProjectInfoReq, CreateProjectReq, CreateTextBoxReq, CreateTextReq } from '../dto/ReqDtoRepository';
import { CareerType, DividerType, FormationType, ProjectElementType, CareerPeriodType, ProjectInfoType } from '../enum/EnumRepository';
import { OnBoardingData } from '../dto/EntityRepository'
import { normalizeFormationType } from '../util/formationUtils';
import { createEmptyProjectInfoValue } from '../util/projectInfo';
// project
export const projectBuilder = (newTitle: string, index: number): CreateProjectReq => {
  return {
    originUrl: '',
    title: newTitle,
    index
  };
}

// projectInfo
export const piBuilder = (parentId: string, index: number): CreateProjectInfoReq => {
  return {
    projectId: parentId,
    type: ProjectInfoType.OTHER,
    customName: null,
    customValues: [createEmptyProjectInfoValue()],
    index
  };
}

export const peTextImportBuilder = (projectId: string, textId: string, textBlockIds: string[]): CreateProjectElementWithTextReq => {
  return {
    projectId: projectId,
    textId: textId,
    textBlockIds: textBlockIds,
  };
}

export const peTextBoxBuilder = (projectId: string): CreateProjectElementReq => {
  return {
    projectId: projectId,
    projectElementType: ProjectElementType.TEXTBOX,
    createTextBoxReq: textBoxBuilder(),
  };
}
export const peDividerBuilder = (projectId: string): CreateProjectElementReq => {
  return {
    projectId: projectId,
    projectElementType: ProjectElementType.DIVIDER,
    dividerType: DividerType.PLAIN,
  };
}

export const formationBuilder = (
  formationType: FormationType = FormationType.TWO_COLUMNS,
): CreateFormationReq => ({
  formationType: normalizeFormationType(formationType),
});

export const peFormationBuilder = (
  projectId: string,
  formationType: FormationType = FormationType.TWO_COLUMNS,
): CreateProjectElementReq => ({
  projectId,
  projectElementType: ProjectElementType.FORMATION,
  createFormationReq: formationBuilder(formationType),
});

export const peCarouselBuilder = (projectId: string): CreateProjectElementReq => ({
  projectId,
  projectElementType: ProjectElementType.CAROUSEL,
  createCarouselReq: {},
});

// Career
export const careerBuilder = (careerType: CareerType, periodType: CareerPeriodType): CreateCareerReq => {
  return {
    careerType,
    periodType,
    content: "",
  };
}

// TextBox
export const textBoxBuilder = (): CreateTextBoxReq => {
  return {
    content: "",
  };
}


export const getDefaultOnBoardingData = (): OnBoardingData => ({
  email: '',
  verifiedEmail: false,
  handle: '',
  verifiedHandle: false,
  signupArchiveType: null,
  works: [],
  isPreviewGuideMode: false,
  isAgreePolicy: false,
});


// Text
export const textBuilder = (): CreateTextReq => {
  return {
    title: "New Text",
    author: '',
    prodYear: new Date().getFullYear().toString(),
  };
}
